module.exports = __webpack_public_path__ + "695cfe75af7db40d107e617a042b6979.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/history/9.jpg
// module id = 309
// module chunks = 0